<div class="help-center">
	<mat-tab-group [dynamicHeight]="false" [(selectedIndex)]="tabIndex" (selectedTabChange)="onTabChange()">
		<mat-tab onselect="">
			<ng-template mat-tab-label>
				<mat-icon class="example-tab-icon">question_answer</mat-icon>
				{{'HelpCenter.HowTo'|translate}}
			</ng-template>
			<howto></howto>
		</mat-tab>
		<mat-tab>
			<ng-template mat-tab-label>
				<mat-icon class="example-tab-icon">format_size</mat-icon>
				{{'HelpCenter.Abbriviation'|translate}}
			</ng-template>
			<abbr></abbr>
		</mat-tab>

	</mat-tab-group>
</div>
